module.exports = {
  contactURL: 'https://on2npssh20.execute-api.eu-central-1.amazonaws.com/Prod/contact-request',
  // contactURL: 'http://127.0.0.1:3000/contact-request',
};
